import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'nx-ng-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
})
export class ModalHeaderComponent implements AfterViewInit {
  @Input()
  title = '';

  @Input()
  showTicket = false;

  @ViewChild('closeBtn') closeBtnElement: ElementRef | undefined;
  ngAfterViewInit() {
    if (this.closeBtnElement) this.closeBtnElement.nativeElement.focus();
  }
}
